import { useRef } from 'react';
import { useSetDataAttrs } from '../../../hooks/use-set-data-attrs';

export function Div(props) {
  const { desc } = props;

  /**
   *
   * @type {React.MutableRefObject<HTMLDivElement>}
   */
  const ref = useRef();

  useSetDataAttrs(ref, desc.dataset);

  return (
    <div
      id={desc.id}
      className={desc.className}
      ref={ref}
      tabIndex={desc.focusable ? 0 : undefined}
      data-auto-focus={desc.autoFocus}
    >
      <div role="outline-decorator" />
      {desc.children.map((child) => (
        <child.type key={child.id} desc={child} />
      ))}
    </div>
  );
}
